import {
  MODEL_CAPABILITIES,
  MODEL_CAPABILITIES_VALUES,
  ModelCapability,
} from "domains/models/constants/capabilities";
import _ from "lodash";

export function getApiCapabilities(
  type: "all" | "image" | "texture" | "3d" | "video" | "video-upscale"
) {
  if (type === "all") {
    return Object.values(MODEL_CAPABILITIES_VALUES).flat();
  }
  if (type === "video-upscale") {
    return MODEL_CAPABILITIES_VALUES["video-video"];
  }
  return _.compact(
    MODEL_CAPABILITIES.map((capability) => {
      const capabilityType = capability.split("-")[0];
      if (type === capabilityType) {
        return MODEL_CAPABILITIES_VALUES[capability];
      }
      return undefined;
    })
  ).flat();
}

export const TEXTURE_CAPABILITIES = getApiCapabilities("texture");

export function getApiCapabilitiesFromFilter(capabilities: ModelCapability[]) {
  return capabilities
    .map((capability) => {
      return MODEL_CAPABILITIES_VALUES[capability];
    })
    .flat();
}
